import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import { loadPageBySlug } from '../../../redux/modules/singlePage';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';
import ContactForm from '../../shared/ContactForm/ContactForm';

import { FaSpinner } from 'react-icons/fa';

import './Pagina.scss';
import { cleanImage } from '../../../utils/images.js';

class Pagina extends Component {
  render() {
    let { page, loading, siteName, logoImage } = this.props;

    return (
      <div className={`pagina ${page.slug}`}>
        <Helmet
          title={page.title}
          meta={[
            { name: 'description', content: `${siteName} - ${page.title}` },
            { name: 'keywords', content: `${siteName}, ${page.title}` },
            { property: 'og:title', content: `${siteName} - ${page.title}` },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - ${page.title}`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          <div className="content-wrapper">
            {loading && (
              <div className="loading">
                <FaSpinner className="pulse" />
              </div>
            )}
            {!loading && !!page && (
              <div className="page-text">
                {!page.isIubenda && <h1>{page.title}</h1>}

                {!!page.imageUrl && (
                  <div
                    className="img-container"
                    style={{
                      backgroundImage: `url(${page.imageUrl})`,
                    }}
                  ></div>
                )}

                <div dangerouslySetInnerHTML={{ __html: page.content }}></div>
              </div>
            )}
            {page.slug === 'contattaci' && (
              <ContactForm hasFreshdesk={this.props.features.hasFreshdesk} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    page: state.singlePage.data,
    loading: state.singlePage.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    features: state.store.data.features,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Pagina, [loadPageBySlug])
);
